import {
  checkUserPermissionLevel,
  PermissionExpr,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  PermissionLevel,
  toPermissionsMap,
} from '@cfa/pathway-fe-shared';

import useAuth from '@/hooks/useAuth';

/**
 * Check whether the current user holds a given permission level.
 *
 * Accepts any expression from {@link PermissionLevel}: simple levels,
 * negation (`not`), minimum-threshold (`atLeast`), and fluent
 * `.and` / `.or` combinations.
 *
 * Returns `false` when `authResponse` is `undefined`.
 *
 * @see {@link https://cfacorp.atlassian.net/wiki/spaces/TEAM/pages/3781493005 Pathway WAS Application Permissions}
 */
export const useUserPermissionLevel = (level: PermissionExpr) => {
  const { data: auth } = useAuth();
  if (!auth) return false;
  const perms = toPermissionsMap(auth);
  return checkUserPermissionLevel(perms, level);
};
